<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
    created() {
        this.$store.dispatch("lookups/getLookups");
        this.$store.dispatch("lookups/getAppointmentTypes");

    },
    computed: {
        types() {
            return this.$store.state.lookups.appointmentTypes

        },
        administrationTypes() {
            return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.AdministrationTypes)

        },
        administrations() {
            return this.$store.state.lookups.administrations;
        },
        departments() {
            return this.$store.state.lookups.departments;
        },
        units() {
            return this.$store.state.lookups.units;
        },
         assignments() {
            return this.$store.state.directorsAppointments.assignments;
        },
        
    },
    data() {
        return {
            employees: [],
            currentDirector: {
                value: null,
                label: null,
            }
            ,
            appointment: {
                isAssignment:false,
                assignmentId:null,
            },
        };
    },
    methods: {
        changeType() {
            this.$store.dispatch("lookups/getAdministrationsByType", this.appointment.administrationTypeId);

        },
        getDepartments() {
            this.$store.dispatch("lookups/getDepartments", this.appointment.administrationId);

        },
        changeAdministration() {
    
            if (this.appointment.administrationTypeId != 1002) {
                this.$store.dispatch("lookups/getDepartments", this.appointment.administrationId);
            }
            else {
                this.$store.dispatch("lookups/getUnitsById", {
                    typeId: 1,
                    id: this.appointment.administrationId,
                });
            }
        },
        changeDepartment() {
            this.$store.dispatch("lookups/getUnitsById", {
                typeId: 2,
                id: this.appointment.departmentId,
            });
        },
        changeAssignment(){
            this.appointment.employeeId = null
            this.employees = [];
            if (this.appointment.isAssignment) {              
                this.$store.dispatch("lookups/getEmployeesByAssignment")
                .then((res) => {
                    this.employees = res.employees
                })
                .catch(() => { });
                        } 
            else{
                this.getEmployees();
            }
          
        },
        getInfo() {
            this.getEmployees();
            this.getCurrenttDirector();
        },
        getEmployees() {
            let params = {
                type: this.appointment.typeId,
                id: this.appointment.typeId == 11001 ? this.appointment.administrationId :this.appointment.typeId == 11002 ? this.appointment.departmentId :this.appointment.unitId 
            }
            this.$store.dispatch("lookups/getManagementEmployees", params)
                .then((res) => {
                    this.employees = res.employees
                })
                .catch(() => { });
        },
        getCurrenttDirector() {
            let params = {
                type: this.appointment.typeId,
                id: this.appointment.typeId == 11001 ? this.appointment.administrationId :this.appointment.typeId == 11002 ? this.appointment.departmentId :this.appointment.unitId 
            }
            this.$store.dispatch("directorsAppointments/getCurrenttDirector", params)
                .then((res) => {
                    this.currentDirector.value = res.director.value;
                    this.currentDirector.label = res.director.label;
                })
                .catch(() => { });
        },
        setEmployee() {
            if (this.currentDirector.value == this.appointment.employeeId) {
                showAlert(`لا يمكن اعادة تعيين نفس الموظف  `);
                this.appointment.employeeId = null
                return;
            }
            //this.getAssignments();
        },
        getAssignments() {
            this.appointment.employeeId = null
            this.employees = [];
            this.appointment.assignmentId = null;
            if (this.appointment.isAssignment) {              
                this.$store.dispatch("directorsAppointments/getAssignments");
            } 
            else{
                this.getEmployees();
            }
            },
        confirm() {
            let payload = {
                type: this.appointment.typeId,
                managerId: this.appointment.employeeId,
                isAssignment: this.appointment.isAssignment,
                assignmentId: this.appointment.assignmentId,
                managementId: this.appointment.typeId == 11001 ? this.appointment.administrationId :this.appointment.typeId == 11002 ? this.appointment.departmentId :this.appointment.unitId 
            }
            this.$store
                .dispatch("directorsAppointments/add", payload)
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },

        back() {
            this.$emit("back");
        },
    },
};
</script>